import React from "react";
import FooterView from "../view/FooterView";

export default function FooterController() {

    return <FooterView />
}